<template>
    <div :id="'editorjs-' + id" class="editorjs content"></div>
</template>

<script>
    import EditorJS from "@editorjs/editorjs";
    import Paragraph from '@editorjs/paragraph';//TODO not working
    import Header from '@editorjs/header';
    import Embed from '@editorjs/embed';
    import Table from '@editorjs/table';
    import Marker from '@editorjs/marker';
    import Quote from '@editorjs/quote';
    import Underline from '@editorjs/underline';
    import Warning from '@editorjs/warning';
    import ImageTool from '@editorjs/image';
    import NestedList from '@editorjs/nested-list';
    import CheckList from '@editorjs/checklist';
    import Attaches from '@editorjs/attaches';

    import Delimiter from '@/components/editorjs/Delimiter';
    import FontSize from 'editorjs-inline-font-size-tool';
    import FontFamily from 'editorjs-inline-font-family-tool';
    import TextColor from '@/components/editorjs/TextColor';

    import AlignmentTuneTool from 'editorjs-text-alignment-blocktune';

    import axios from "axios";
    import {apiUrl} from "@/http_client";

    export default {
        props: ['data'],
        data: function() {
            return {
                id: null,
                editor: null
            };
        },
        mounted() {
            this.id = Math.random().toString(36).slice(2, 7);

            let editor = new EditorJS({
                holder: 'editorjs-' + this.id,
                placeholder: 'Add content...',
                defaultBlock: 'paragraph',
                inlineToolbar: ['bold', 'italic', 'underline', 'marker', 'color', 'fontSize', 'fontFamily', 'link'],
                minHeight: 0,
                tools: {
                    header: {
                        class: Header,
                        config: {
                            placeholder: 'Enter a header',
                            levels: [1, 2, 3, 4, 5, 6],
                            defaultLevel: 3,
                        },
                        inlineToolbar: true,
                        tunes: ['alignTune']
                    },
                    // INLINE
                    marker: Marker,
                    underline: Underline,
                    color: {
                        class: TextColor,
                        config: {
                            colorCollections: ['#FF1300', '#EC7878', '#9C27B0', '#673AB7', '#3F51B5', '#0070FF', '#03A9F4', '#00BCD4', '#4CAF50', '#8BC34A', '#CDDC39', '#000', '#4a4a4a', '#666', '#999'],
                            defaultColor: '#4a4a4a',
                            type: 'text',
                        }
                    },
                    fontSize: FontSize,
                    fontFamily: FontFamily,
                    // BLOCKS
                    paragraph: {
                        class: Paragraph,
                        inlineToolbar: true,
                        tunes: ['alignTune']
                    },
                    quote: Quote,
                    table: {
                        class: Table,
                        inlineToolbar: true
                    },
                    list: {
                        class: NestedList,
                        inlineToolbar: true,
                    },
                    checklist: {
                        class: CheckList,
                        inlineToolbar: true,
                    },
                    delimiter: Delimiter,
                    embed: {
                        class: Embed,
                        config: {
                            services: {
                                youtube: true,
                                vimeo: true
                            }
                        }
                    },
                    image: {
                        class: ImageTool,
                        config: {
                            uploader: {
                                uploadByFile(file) {
                                    console.log('uploadByFile', apiUrl + 'components/image/data', window.token);
                                    let formData = new FormData();
                                    formData.append('image', file);
                                    return axios.post(apiUrl + 'components/image/data', formData, {
                                        headers: {
                                            'Authorization': window.token,
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    }).then(response => {
                                        return response.data;
                                    }).catch(() => {
                                        return {success: 0};
                                    });
                                },
                                uploadByUrl(url) {
                                    return http.post('components/image/url', {url}).then(response => {
                                        return response.data;
                                    });
                                }
                            }
                        }
                    },
                    warning: {
                        class: Warning,
                        inlineToolbar: true,
                        config: {
                            titlePlaceholder: 'Title',
                            messagePlaceholder: 'Message',
                        },
                    },
                    // TUNES
                    alignTune: {
                        class: AlignmentTuneTool,
                        config: {
                            default: "left",
                            blocks: {
                                paragraph: 'left',
                                header: 'left',
                                list: 'left'
                            }
                        },
                    }
                },
                onReady: () => {

                },
                onChange: () => {
                    this.$saveAlert(true, 'Are you done editing this component? Unsaved changes will be lost.'); // TODO shouldn't be here?
                    editor.save().then(saved => {
                        this.$emit('save', saved);
                    });
                },
                data: this.data
            });

            window.editors.push(editor);
        }
    };
</script>

<style lang="scss">
    .editorjs {
        // all instances run minHeight: 0, but editor.js only applies it (as inline
        // padding-bottom: 0) after async init — pin it so first mount doesn't flash tall
        .codex-editor__redactor {
            padding-bottom: 0 !important;
        }
    }

    h4 {
        font-size: 2rem;
    }

    svg.icon {
        width: 14px !important;
        height: 14px !important;

        align-items: normal;
        display: inline;
        justify-content: normal;
    }

    .ce-block__content,
    .ce-toolbar__content {
        max-width: unset;
    }

    .ce-toolbar__actions {
        top: 1px;
        right: 15px;
    }

    @media (min-width: 651px) {
        .ce-toolbar__actions {
            top: 1px;
            right: 15px !important;
        }
    }

    .ce-toolbar__plus {
        left: 5px;
    }

    .ce-toolbox {
        left: 35px;

        li:first-child {
            margin-top: 0.25em;
        }
    }

    .ce-block {
        border-left: 4px solid transparent;
        margin: 0.6rem 0 !important;
        padding-left: 2rem;

        &.ce-block--focused {
            border-color: #336699;
        }

        &.ce-block--stretched {
            border-right: 0.4rem solid white;
        }

        table {
            margin-bottom: 0 !important;

            td {
                padding: 0 !important;
                border-width: 1px !important;
            }

        }

        .tc-table__wrap {
            margin: 2rem 0;
        }
    }

    .ce-paragraph {
        line-height: normal !important;
    }

    .cdx-block {
        padding: 0;
    }

</style>
